import React, { useMemo } from 'react';
import { getIn } from 'formik';
import { useItemCreationContext } from '~/ModularComponents/ItemCreation/ItemCreation';
import { Switcher } from '~/UIKit';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

interface IInputSwitcherProps<T> {
  name: keyof T;
  placeholder?: string;
  secondaryPlaceholder?: string;
}

const useStyles = makeStyles(
  {
    container: {
      marginLeft: 'auto',
      color: PRIMARY_BLUE,
      '& input': {
        textAlign: 'right',
      },
    },
  },
  { name: 'inputSwitcher' },
);

export const InputSwitcher = <T extends object>({
  name,
  placeholder,
  secondaryPlaceholder,
}: IInputSwitcherProps<T>) => {
  const {
    isLoading,
    disabled,
    values,
    touched,
    setTouched,
    setFieldValue,
  } = useItemCreationContext();
  const { classes } = useStyles();

  const value = getIn(values, name as string);
  const isDisabled = getIn(disabled, name as string);

  const handleBlur = () => {
    setTouched({ ...touched, [name]: true }, true);
  };

  return useMemo(
    () => (
      <Switcher
        className={classes.container}
        name={name as string}
        checked={value}
        onChange={(e) => setFieldValue(name as string, e.target.checked)}
        disabled={isDisabled || isLoading}
        placeholder={placeholder}
        secondaryPlaceholder={secondaryPlaceholder}
        onBlur={handleBlur}
      />
    ),
    [value, isDisabled, isLoading, placeholder, secondaryPlaceholder],
  );
};
